// extracted by mini-css-extract-plugin
export var growableInput = "_3p-0";
export var tagContainer = "_3p-2";
export var textInput = "_3p-1";